// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"e81ec3e9","163":"1cb95cbd","254":"f63fba3d","296":"f1f45226","299":"2f8ad654","432":"a4f9a556","558":"83594f3b","606":"86bdf652","659":"420af033","669":"84750473","682":"16446166","733":"ae2bdd9f","978":"01540b2c"}[chunkId] + ".chunk.js";
};